import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    routes: [
        {path: '/', component: () => import('./views/Dashboard')},
        {path: '/login', component: () => import('./views/Login')},
        {path: '/forgot', component: () => import('./views/Forgot')},
        {path: '/change', component: () => import('./views/Profile')},
        {path: '/reset/:token', component: () => import('./views/Reset'), props: true},
        {path: '/admin', component: () => import('./views/Admin')},
        {path: '/client', component: () => import('./views/Client')},
        {path: '*', redirect: '/'}
    ],
})
